import React from "react";

const SubcategoriesEmpty = () => <div>There are no subcategories created for this category yet.</div>;

export default SubcategoriesEmpty;
